const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://travelapp-bens.onrender.com' 
  : 'http://localhost:5001';

class CSRFTokenManager {
  private static instance: CSRFTokenManager;
  private token: string | null = null;
  private tokenPromise: Promise<string> | null = null;

  private constructor() {}

  public static getInstance(): CSRFTokenManager {
    if (!CSRFTokenManager.instance) {
      CSRFTokenManager.instance = new CSRFTokenManager();
    }
    return CSRFTokenManager.instance;
  }

  public async getToken(): Promise<string> {
    // If we already have a token, return it
    if (this.token) {
      return this.token;
    }

    // If we're already fetching a token, wait for that promise
    if (this.tokenPromise) {
      return this.tokenPromise;
    }

    // Create a new token fetch promise
    this.tokenPromise = this.fetchToken();
    
    try {
      this.token = await this.tokenPromise;
      return this.token;
    } finally {
      this.tokenPromise = null;
    }
  }

  public clearToken(): void {
    this.token = null;
    this.tokenPromise = null;
  }

  private async fetchToken(): Promise<string> {
    try {
      console.log('🔐 CSRFTokenManager: Fetching fresh CSRF token');
      
      const response = await fetch(`${API_BASE_URL}/api/csrf-token`, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch CSRF token: ${response.status}`);
      }

      const data = await response.json();
      if (!data.csrfToken) {
        throw new Error('No CSRF token in response');
      }

      console.log('🔐 CSRFTokenManager: Successfully fetched token');
      return data.csrfToken;
    } catch (error) {
      console.error('🔐 CSRFTokenManager: Error fetching token:', error);
      throw error;
    }
  }
}

export const csrfTokenManager = CSRFTokenManager.getInstance(); 